import { useEffect } from 'react'

import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_CRITICAL,
  INDENT_CONTENT_COMMAND,
  KEY_TAB_COMMAND,
  OUTDENT_CONTENT_COMMAND
} from 'lexical'

import { useEditor } from '../../hooks/useEditor'

export const TabIndentationPlugin = () => {
  const editor = useEditor()

  useEffect(() => {
    return editor.registerCommand(
      KEY_TAB_COMMAND,
      event => {
        const selection = $getSelection()
        if (!$isRangeSelection(selection)) {
          return false
        }
        event.preventDefault()
        const command = event.shiftKey
          ? OUTDENT_CONTENT_COMMAND
          : INDENT_CONTENT_COMMAND
        return editor.dispatchCommand(command, undefined)
      },
      COMMAND_PRIORITY_CRITICAL
    )
  }, [editor])

  return null
}
